$(function() {

body = $('body');

var delayHeight,
winH,
winW,
footer_pos;

function delayAnimeInt(){
	if(window.matchMedia('(max-width:767px)').matches){
		delayHeight = 0;
	}else{
		delayHeight = 100;
	}
	delaySet();
	footer_pos = $('#footer').offset().top;
	delayAnime();
	scrlClass();
}
function delaySet(){
	var setElm = $('.anime');
	winH = $(window).height();
	winW = $(window).width();
	setElm.each(function(){
		var setThis = $(this),
		obj = setThis.find(".obj"),
		elmHeight = setThis.height();
		// for(var i=0;i<obj.length;i++){
		// 	var delaytime = i*200 + 300;
		// 	obj.eq(i).css({transitionDelay: delaytime+'ms' });	
		// }

	});
}

var scrTop = 1,
scrl_before = $(window).scrollTop(),
scrl_after;
function delayAnime(){
	scrTop = $(window).scrollTop();
	var setElm = $('.anime');
	setElm.each(function(){
		var setThis = $(this),
		elmHeight = setThis.height(),
		elmTop = setThis.offset().top;
		if (scrTop > elmTop - winH + delayHeight && scrTop < elmTop + elmHeight){
			if(!setThis.hasClass('active')){
				setThis.addClass("active");
			}
		}
	});
	var sElm = $('.elm');
	sElm.each(function(){
		var setThis = $(this),
		elmHeight = setThis.height(),
		elmTop = setThis.offset().top;
		if (scrTop > elmTop - winH + delayHeight && scrTop < elmTop + elmHeight){
			if(!setThis.hasClass('active')){
				setThis.addClass("active");
			}
		}
	});
	scrlClass();
}

function scrlClass(){
	if(scrTop<30){
		body.addClass("scrl_top");
		body.removeClass("scrl");
	}else{
		body.removeClass("scrl_top");
		body.addClass("scrl");
	}
	if(scrTop>winH-60){
		body.addClass("scrl_oneview");
	}else{
		body.removeClass("scrl_oneview");
	}
	var bottom_h = 200;
	if(scrTop > footer_pos - winH + bottom_h ) {
		body.addClass("scrl_end");
	}else{
		body.removeClass("scrl_end");
	}


	if(window.matchMedia('(max-width:767px)').matches){
		scrl_after = scrTop - 100;
	}else{
		scrl_after = scrTop - 100;
	}
	if(scrl_after <= 0){
		body.removeClass('scrl_down');
	}else{
		if(scrl_before < scrl_after) {
			body.addClass('scrl_down');
		}
		else if(scrl_before > scrl_after) {
			body.removeClass('scrl_down');
		}
	}
	scrl_before = scrl_after;

	nav_hide();
}


function nav_show(){
	body.addClass('navopen');
}
function nav_hide(){
	body.removeClass('navopen');
}
function navInit(){
	$('#nav_btn').on('click', function(){
		nav_show();
	});
	$('#nav_close').on('click', function(){
		nav_hide();
	});
	$('.hassub_btn').on('click', function(e){
		$(this).parent().toggleClass('active');
		var touch_event = window.ontouchstart;
		var touch_points = navigator.maxTouchPoints;
		if( touch_event !== undefined && 0 < touch_points ) {
			return false;
		}
	});
}


var setFillHeight = function setFillHeight() {
	const vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', vh+'px');
}
setFillHeight();
window.addEventListener('resize', setFillHeight);


var swiper;
function imageSlide(){
	let $slider = $('#slider');
	swiper = new Swiper('#imgSwiper', {
		effect: 'fade',
		speed: 2000,
		spaceBetween: 0,
		preventClicks: false,
		preventClicksPropagation: false,
		loop: true,
		autoplay: {
			delay: 4000,
			disableOnInteraction: false,
		},
		keyboard: {
			onlyInViewport: false,
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			clickable: true,
		},
		fadeEffect: {
			crossFade: true
		}
	});
}
function startSlide(){
	swiper.autoplay.start();
}
function stopSlide(){
	swiper.autoplay.stop();
}


function product_slider(){
	var item_slider = new Swiper('#item_slider', {
		spaceBetween: 10,
		loop: true,
		threshold: 10,
		navigation: {
			nextEl: '.swiper_next',
			prevEl: '.swiper_prev',
		},
		pagination: {
			el: ".swiper-pagination",
			type: 'bullets',
			clickable: true,
		},
	});
	var item_full_slider = new Swiper('#item_full_slider', {
		spaceBetween: 10,
		loop: true,
		threshold: 10,
		navigation: {
			nextEl: '.swiper_next',
			prevEl: '.swiper_prev',
		},
		pagination: {
			el: ".swiper-pagination",
			type: 'bullets',
			clickable: true,
		},
	});
	$('#fullscreen_btn').on('click',function(){
		var num = $('#item_slider .swiper-slide-active').attr('data-num');
		item_full_slider.slideTo(num, 0);
		body.addClass('fullscreen');
	})
	$('#fullscreen_close').on('click',function(){
		body.removeClass('fullscreen');
	})
}


function recommend_slider(){
	var recommend_slider = new Swiper('#recommend_slider', {
		spaceBetween: 20,
		slidesPerView: 1.5,
		loop: false,
		loopedSlides: 5,
		threshold: 10,
		navigation: {
			nextEl: '.reco_next',
			prevEl: '.reco_prev',
		},
		pagination: {
			el: ".reco-pagination",
			type: "fraction",
		},
		watchSlidesVisibility: true,
		watchSlidesProgress: true,
		centeredSlides: true,
		breakpoints: {
			768: {
				slidesPerView: 3,
			},
			1200: {
				slidesPerView: 4,
			}
		}
	});
}


function anchorscrl(){
	$('a.anchor').on('click', function(){
		let href = $(this).data('tag'),
		target = $(href === "#" || href === "" ? 'html' : href);
		target.velocity("scroll", { duration: 1000, delay:0, easing: "easeOutQuint", offset: 0 });
		nav_hide();
	});
}


function dynamic_checkout(){
	setTimeout(function(){
		$('.shopify-payment-button__button--unbranded').text('Buy it now');
	},1000);
}

function contactFunc(){
$('.inpt_efct').keyup(function() {
	if( $(this).val() ) {
		$(this).addClass('has_content');
	} else {
		$(this).removeClass('has_content');
	}
});
}

var timeoutId ;
window.addEventListener( "resize", function () {
	if ( timeoutId ) return ;
	timeoutId = setTimeout( function () {
		timeoutId = 0 ;
		winH = $(window).height();
		delayAnimeInt();
	}, 500 ) ;
} ) ;


function initialize(){
	body.addClass('ready');
	delayAnimeInt();
	anchorscrl();
	delayAnime();
	navInit();
	dynamic_checkout();
	$('#wrapper').imagesLoaded( { background: true }, function() {
		footer_pos = $('#footer').offset().top;
	});
}
initialize();

$(window).on('scroll',function(){
	delayAnime();
});


if( document.getElementById('slider') ){
	imageSlide();
	startSlide();
}
if( document.getElementById('top') ){
	body.addClass('top');
	var random = Math.floor( Math.random() * 3 ) +1;
	$('#kvimg'+random).css({"opacity":1});
}
if( document.getElementById('product') ){
	product_slider();
	recommend_slider();
}
if( document.getElementById('faq') ){
	$('.exbtn').on('click', function(){
		$(this).parents('.ex').toggleClass('open');
	});
}
if( document.getElementById('contact') ){
	contactFunc();
}
if( document.getElementById('cart_page') ){
	body.addClass('cart_page');
}


});

